import { getRequest } from '@/core';
import { deviations } from '@/requests';

export default async function getDeviationByIdRequest(id) {
	let url = deviations.getByIdPath(id);
	let response = await getRequest(url);
	return response;
}
